import { AdvisorTopics } from 'components/features/coaching/advisorMeeting/fixtures/requestQuestions'
import { AdvisorUid, Advisor } from 'components/features/coaching/advisor/types/advisor'
import { RawForwardPaginatable } from 'interfaces/table'

export type AdvisorRequestTopic = {
  question: string
  answer: AdvisorTopics[]
}
export type WithAdvisorRequestTopic = {
  topics: AdvisorRequestTopic
}

export type AdvisorRequestNotes = {
  question: string
  answer: string
}
export type WithAdvisorRequestNotes = {
  notes: AdvisorRequestNotes
}

export const FLOR_REGULAR = 'regular' as const
const FLOR_PROFILE = 'profile' as const
const FLOR_LANDING = 'landing' as const
export type MeetingPaneFlow =
  | typeof FLOR_REGULAR
  | typeof FLOR_PROFILE
  | typeof FLOR_LANDING

export type AdvisorMeetingWizardRegularSpecificFields = {
  flow: typeof FLOR_REGULAR,
}

export type AdvisorMeetingWizardProfileSpecificFields = {
  flow: typeof FLOR_PROFILE
  advisor_uid: AdvisorUid
  isSignUpStepSucceed?: boolean
}

export type AdvisorMeetingWizardLandingSpecificFields = {
  flow: typeof FLOR_LANDING
  income: number
  zip5: string
  isSignUpStepSucceed?: boolean
}

export type AdvisorMeetingWizardNonRegularSpecificFields =
  | AdvisorMeetingWizardProfileSpecificFields
  | AdvisorMeetingWizardLandingSpecificFields

export type FlowSpecificFields =
  | AdvisorMeetingWizardRegularSpecificFields
  | AdvisorMeetingWizardNonRegularSpecificFields

type WizardFields = {
  topics: AdvisorTopics[]
  notes: string
  timeslot: string
  advisor_uid: AdvisorUid
}

export type AdvisorMeetingWizardFields =
  & WizardFields
  & FlowSpecificFields

export type AdvisorMeetingWizardNonRegularFields =
  & WizardFields
  & AdvisorMeetingWizardNonRegularSpecificFields

export type AdvisorApiOutput =
  & Advisor
  & {
    timeslots: RawForwardPaginatable<string>
  }

export type CreateAdvisorMeetingApiInput =
  & WithAdvisorRequestTopic
  & WithAdvisorRequestNotes
  & {
    advisor_uid: AdvisorUid
    timeslot: string
  }

export class TimeSlot {
  constructor (
      public date: string,
      public isAvailable = true,
  ) {}
}
